export default {
  el: {
    colorpicker: {
      clear: 'Исчисти',
      confirm: 'ОК',
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Откажи",
      clear: "Исчисти",
      confirm: "ОК",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "Јануари",
      month2: "Февруари",
      month3: "Март",
      month4: "Април",
      month5: "Мај",
      month6: "Јуни",
      month7: "Јули",
      month8: "Август",
      month9: "Септември",
      month10: "Октомври",
      month11: "Ноември",
      month12: "Декември",
      week: "week",
      weeks: {
        sun: "Нед",
        mon: "Пон",
        tue: "Вто",
        wed: "Сре",
        thu: "Чет",
        fri: "Пет",
        sat: "Саб",
      },
      months: {
        jan: "Јан",
        feb: "Фев",
        mar: "Мар",
        apr: "Апр",
        may: "Мај",
        jun: "Јун",
        jul: "Јул",
        aug: "Авг",
        sep: "Сеп",
        oct: "Окт",
        nov: "Ное",
        dec: "Дек",
      },
    },
    select: {
      loading: "Се вчитува",
      noMatch: "Нема соодветни податоци",
      noData: "Нема податоци",
      placeholder: "Избери",
    },
    cascader: {
      noMatch: "Нема соодветни податоци",
      loading: "Се вчитува",
      placeholder: "Избери",
      noData: "Нема податоци",
    },
    pagination: {
      goto: "Оди до",
      pagesize: "", // /страница
      total: "Вкупно {вкупно}",
      pageClassifier: "",
    },
    messagebox: {
      title: "Порака",
      confirm: "ОК",
      cancel: "Откажи",
      error: "Нелегален внес",
    },
    upload: {
      deleteTip: "Притисни на избриши за да отстраниш",
      delete: "Избриши",
      preview: "Преглед",
      continue: "Продолжи",
    },
    table: {
      emptyText: "Нема податоци",
      confirmFilter: "Потврди",
      resetFilter: "Ресетирај",
      clearFilter: "Сите",
      sumText: "Збир",
    },
    //tree: {
    //  emptyText: 'No Data'
    //},
    //transfer: {
    //  noMatch: 'No matching data',
    //  noData: 'No data',
    //  titles: ['List 1', 'List 2'], // to be translated
    //  filterPlaceholder: 'Enter keyword', // to be translated
    //  noCheckedFormat: '{total} items', // to be translated
    //  hasCheckedFormat: '{checked}/{total} checked' // to be translated
    //},
    image: {
      error: "НЕУСПЕШНО",
    },
    pageHeader: {
      title: "Назад", // to be translated
    },
    popconfirm: {
      confirmButtonText: "Да",
      cancelButtonText: "Не",
    },
    empty: {
      description: "Нема податоци",
    },
  },
};
